<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <meta-section>
          <div class="text-right">
            <div class="d-flex flex-row gap-2">
              <SyncButton :checked="[data.id]" />
              <ArgonButton
                :to="{ name: 'Master Data Pegawai Edit', params: { id: this.$route.params.id } }"
                isRouteLink
              >
                Ubah</ArgonButton
              >
            </div>
          </div>
        </meta-section>
      </div>
      <div class="col-12">
        <div class="d-flex flex-column gap-4">
          <CardComponent :withmin="false">
            <fieldset-component title="Informasi Pegawai" isFieldsetRow>
              <div class="row">
                <div class="col-md-12">
                  <div style="width: 11.1112vw;height: 11.1112vw;position: relative;margin: 0 auto;">
                    <img v-if="data.photo!='' && data.photo != null" :src="data.photo" alt="Employee" class="img-fluid" style="width: 11.1112vw;height: 11.1112vw;">
                    <img v-else :src="require('@/assets/img/avatar.png')" alt="Default avatar" class="img-fluid" style="width: 11.1112vw;height: 11.1112vw;">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Nama Lengkap" class="m-0">
                      {{ data.name ?? "&nbsp;" }}
                    </FormGroup>

                    <FormGroup label="NIP" class="m-0">
                      {{ data.nip ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Email" class="m-0">
                      {{ data.user?.[0]?.email ?? "&nbsp;" }}
                    </FormGroup>

                    <FormGroup label="Status Pegawai" class="m-0">
                      {{ data.employee_status ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Status" class="m-0">
                      <argon-badge v-if="data.syncing == true" color="info">Syncing</argon-badge>
                      <argon-badge v-else-if="data.status == 'active'" color="success">Aktif</argon-badge>
                      <argon-badge v-else-if="data.status == 'inactive'" color="danger">Non Aktif</argon-badge>
                    </FormGroup>

                    <FormGroup label="Hak Akses" class="m-0">
                      {{ getHakAkses(data.user?.[0] ?? {}) }}
                    </FormGroup>
                  </div>
                </div>
              </div>
            </fieldset-component>
          </CardComponent>

          <CardComponent :withmin="false">
            <FieldsetComponent title="Informasi Jabatan" isFieldsetRow>
              <div class="row">
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Periode" class="m-0">
                      {{ data.jabatan?.periode ?? "&nbsp;" }}
                    </FormGroup>
                    <FormGroup label="Jabatan" class="m-0">
                      {{ data.jabatan?.name ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Posisi" class="m-0">
                      {{ data?.position ?? "&nbsp;" }}
                    </FormGroup>
                    <FormGroup label="Level" class="m-0">
                      {{ data.jabatan?.grade ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-2">
                    <FormGroup label="Unit Kerja" class="m-0">
                      {{ data?.unitkerja?.name ?? "&nbsp;" }}
                    </FormGroup>
                  </div>
                </div>
              </div>
            </FieldsetComponent>
          </CardComponent>

          <CardComponent :withmin="false">
            <FieldsetComponent title="Informasi Atasan" isFieldsetRow>
              <div class="row">
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-4">
                    <FormGroup label="Atasan 1">{{ data?.leader?.name ?? "&nbsp;" }}</FormGroup>
                    <FormGroup label="NIP Atasan 1">{{ data?.leader?.nip ?? "&nbsp;" }}</FormGroup>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex flex-column gap-4">
                    <!-- <FormGroup label="Atasan 2">{{ data?.unitkerja?.leader?.name ?? "&nbsp;" }}</FormGroup>
                    <FormGroup label="NIP Atasan 2">{{ data?.unitkerja?.leader?.nip ?? "&nbsp;" }}</FormGroup> -->
                    <FormGroup label="Atasan 2">{{ data?.immediate_supervisor?.name ?? "&nbsp;" }}</FormGroup>
                    <FormGroup label="NIP Atasan 2">{{ data?.immediate_supervisor?.nip ?? "&nbsp;" }}</FormGroup>
                  </div>
                </div>
              </div>
            </FieldsetComponent>
          </CardComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent.vue";
import EmployeesApi from "@/repository/api/EmployeesApi";
// import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import FieldsetComponent from "@/components/FieldsetComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import SyncButton from '../../../components/SyncButton.vue';
export default {
  name: "tables",
  components: {
    CardComponent,
    // ThreeDotsMenu,
    FieldsetComponent,
    FormGroup,
    ArgonBadge,
    ArgonButton,
    MetaSection,
    SyncButton,
  },
  data() {
    return {
      timer: undefined,
      data: {},
    };
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getData();
    this.$store.state.loading = false;
  },
  methods: {
    getHakAkses(item) {
      this.$store.state.loading = true;
      let hakakses = [];

      if ((item.groups ?? []) != []) {
        (item.groups ?? []).forEach((group) => {
          hakakses.push(group?.name);
        });
      }
      this.$store.state.loading = false;

      return hakakses.join(", ");
    },
    async getData() {
      this.$store.state.loading = true;
      await EmployeesApi.get(this.$route.params.id)
        .then((response) => {
          this.data = response.data;
          if (this.data.photo && this.data.photo != null) {
            this.data.photo = String(process.env.VUE_APP_BASE_API).replace(/\/$/, '') + this.data.photo
          }
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      this.$store.state.loading = false;
    },
    getEmployePhoto(path) {
      return "http://localhost:9100" + path;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (response) => {
        if (response.isConfirmed) {
          this.$store.state.loading = true;
          await EmployeesApi.delete(id)
            .then(() => {
              this.getData();
              this.$swal({
                icon: "success",
                title: "Berhasil",
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: error.response.data.message,
              });
            });
          this.$store.state.loading = false;
        }
      });
    },
  },
};
</script>
